export class EnergyGemConversion {
    constructor(gemSection) {
        this.$gemSection = $(gemSection);
        this.$weeklyDrawingEntries = $('#weeklyDrawingEntries');
        this.$conversionBtn = this.$gemSection.find('.button');
        this.$gemsAvailable = this.$conversionBtn.find('#availableGems');
        this.$conversionBtn.one('click', () => this.convertToDrawingEntries());
    }
    convertToDrawingEntries() {
        const self = this;
        const $gem = self.$gemSection.find('.gem-emblem');
        self.$conversionBtn.addClass('disabled no-hover');
        $gem.removeClass('finish-1 finish-5 finish-10 finish-25').addClass('gem-switching');
        self.$gemSection.find('.gem-circle').addClass('spinning');
        window.irep.callApi({
            url: "swic11/energygem/convert",
            type: "POST",
            data: {}
        }).done(function (d) {
            if (d.info) {
                self.$gemsAvailable.html(d.info.availableEnergyGems);
                setTimeout(function () {
                    self.$weeklyDrawingEntries.html("+" + d.info.newDrawingEntries);
                    self.$gemSection.find('.gem-emblem').removeClass('gem-switching').addClass(`finish-${d.info.newDrawingEntries}`);
                }, 2000);
                setTimeout(function () {
                    self.$gemSection.find('.gem-circle').removeClass('spinning');
                    if (d.info.availableEnergyGems > 0) {
                        self.$conversionBtn.one("click", () => self.convertToDrawingEntries());
                        self.$conversionBtn.removeClass('disabled no-hover');
                    }
                }, 2500);
                setTimeout(function () {
                    self.$weeklyDrawingEntries.html(d.info.weeklyDrawingEntries);
                }, 3000);
            }
        });
    }
}
const c = {};
$(".swic11-energy-gem-dash").each((i, elem) => {
    c[i] = new EnergyGemConversion(elem);
});
